// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1_IW5","tab":"Tabs_tab__2NBSD","tabActive":"Tabs_tabActive__3Clx5"};